import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=b106ccd4&scoped=true"
import script from "./whiteList.vue?vue&type=script&lang=js"
export * from "./whiteList.vue?vue&type=script&lang=js"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=b106ccd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b106ccd4",
  null
  
)

export default component.exports